import React, { useEffect, useState, useContext } from "react";
import { Table, Pagination, Dropdown, ButtonGroup, Button } from "react-bootstrap";
import {  faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fetchUrl } from "../../config";
import SideNav from "../SideNav/SideNav";
import { AllContext } from "../../AllContext";


function PhoneLeadsList() {
  const [leads, setLeads] = useState([]);
  const [currentLeads, setCurrentLeads] = useState([]);
  const { setShowAlert, setAlertText, setAlertVariant } = useContext(AllContext)
  const [page, setPage] = useState(1);
  const [pageSize] = useState(5); // show 5 per page
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("New"); // default filter
  const accessToken = localStorage.getItem("access_token");

  // Fetch leads from backend with status filter
  const fetchLeads = async (status = "All") => {
    setLoading(true);
    try {
      let url = `${fetchUrl}/api/phone-leads/?page=${page}`;
      if (status !== "All") {
        url += `&status=${status}`;
      }

      const res = await fetch(url, {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
      });
      if (!res.ok) throw new Error("Failed to fetch leads");
      const data = await res.json();
      setLeads(data);
      setCurrentLeads(data.results || [])
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads(statusFilter);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter, accessToken, page]);

  // Function to update status
  const updateStatus = async (leadId, newStatus) => {
    try {
      const res = await fetch(`${fetchUrl}/api/phone-lead/${leadId}/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (res.ok) {
        fetchLeads(statusFilter)
        // setCurrentLeads((prev) =>
        //   prev.map((l) => (l.id === leadId ? { ...l, status: newStatus } : l))
        // );
        setShowAlert(true)
        setAlertText(` Update Success`)
        setAlertVariant('success')
        console.log(`Status updated to ${newStatus}`);
      } else {
        setShowAlert(true)
        setAlertText(` Fail to Success`)
        setAlertVariant('danger')
        console.error("Failed to update status");
      }
    } catch (err) {
        setShowAlert(true)
        setAlertText(` Fail to Success`)
        setAlertVariant('danger')
        console.error(err);
    }
  };


    // total pages = total count / page size (from backend)
    const totalPages = leads.count ? Math.ceil(leads.count / pageSize) : 1;



  return (
    <div>
      <div className="NavRow">
        <div>
          <SideNav />
        </div>
        <div className="bodyLayout">
          <h4 className="mb-3">📲 Incomplete Orders</h4>

          {/* Status filter buttons */}
          <div  className="mb-3">
            {["All", "New", "Confirm", "Cancel"].map((status) => (
              <Button
                key={status}
                variant={statusFilter === status ? "primary" : "outline-primary"}
                className="me-2"
                onClick={() => {
                  setStatusFilter(status);
                  setPage(1); // reset to first page
                }}
              >
                {status}
              </Button>
            ))}
          </div>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div >
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Product</th>
                    <th>Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentLeads.length > 0 ? (
                    currentLeads.map((lead) => (
                      <tr key={lead.id}>
                        <td>{lead.name || "No Name"}</td>
                        <td>
                          <a className=' text-decoration-none text-dark' href={`tel:${lead.phone}`}>{lead.phone}</a>
                          <a 
                              style={{ cursor: 'pointer' }}  
                              className='text-bg-warning text-decoration-none py-1 px-2 ms-1' 
                              target='blank' 
                              href={`https://steadfast.com.bd/user/frauds/check/${lead.phone}`}>
                              <FontAwesomeIcon icon={faExclamationTriangle} />
                            </a> 
                        </td>
                        <td>
                          <div>
                            <a
                              className=" text-decoration-none"
                              href={`/product/${lead.product_slug}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {lead.product_name || "No Product"}
                            </a>
                            
                            <div className="mt-1 d-flex align-items-center">
                              {lead.product_image ? (
                                <img
                                  src={lead.product_image}
                                  alt={lead.product_name}
                                  style={{ width: "40px", height: "40px", borderRadius: "6px" }}
                                />
                              ) : (
                                "No Image"
                              )}
                              <span className="ps-3">৳ {lead.product_price || 0}</span>
                            </div>
                          </div>
                        </td>
                        <td>{new Date(lead.created_at).toLocaleString()}</td>
                        <td>
                          {/* Dropdown to update status */}
                          <Dropdown as={ButtonGroup}>
                            <Dropdown.Toggle
                              variant={
                                // eslint-disable-next-line no-nested-ternary
                                lead.status === "New"
                                  ? "secondary"
                                  : lead.status === "Confirm"
                                  ? "success"
                                  : "danger"
                              }
                              size="sm"
                            >
                              {lead.status}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              {["New", "Confirm", "Cancel"].map((s) => (
                                <Dropdown.Item key={s} onClick={() => updateStatus(lead.id, s)}>
                                  {s}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No leads found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* Pagination */}
              {totalPages > 1 && (
              <Pagination>
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(pageNumber => 
                    // Show first 2, last 2, and +/- 1 around current page
                    (
                      pageNumber <= 2 ||
                      pageNumber > totalPages - 2 ||
                      Math.abs(pageNumber - page) <= 1
                    )
                  )
                  .map((pageNumber, idx, arr) => {
                    // Add ellipsis when there's a gap between previous and current number
                    const prev = arr[idx - 1];
                    const showEllipsis = prev && pageNumber - prev > 1;

                    return (
                      <React.Fragment key={`page-${pageNumber}`}>
                        {showEllipsis && <Pagination.Ellipsis disabled />}
                        <Pagination.Item
                          active={pageNumber === page}
                          onClick={() => setPage(pageNumber)}
                        >
                          {pageNumber}
                        </Pagination.Item>
                      </React.Fragment>
                    );
                  })}
              </Pagination>
            )}

            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PhoneLeadsList;
